import { React, useState, useEffect, useLayoutEffect } from "react";
import Chart, { Scale } from "chart.js/auto";
import { Card, Col } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import { defaults } from "chart.js";
import "./Activity.scss";
import { activitiesFiltersList } from "../../common/constants/constants";
import {
  getGeccoFilesStat,
  getUsersCount,
  getGeccoUsers,
  getFcUsers,
  getFcBoaData,
  getFcFamilyTreeData,
  getFcStatusQuoData,
} from "../../services/ActivitiesServices";
import Loader from "components/common/loader/Loader";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { localizeGraphData } from "../../utils/Utils";
const Activities = ({ selectedProduct, filters }) => {
  const { t } = useTranslation();
  const [geccoFilesActiveFilter, setGeccoFilesActiveFilter] = useState(4);
  const [isLoading, setIsLoading] = useState(true);
  const [geccoFilesData, setGeccoFilesData] = useState([]);
  const [fcTotalUsers, setFcTotalUsers] = useState(0);
  const [geccoTotalUsers, setGeccoTotalUsers] = useState(0);
  const [geccoPayedUsers, setGeccoPayedUsers] = useState(0);
  const [geccoUsersActiveFilter, setGeccoUsersActiveFilter] = useState(4);
  const [isLoadingGeccoUsers, setIsLoadingGeccoUsers] = useState(true);
  const [geccoUsersData, setGeccoUsersData] = useState([]);
  const [fcUsersActiveFilter, setFcUsersActiveFilter] = useState(4);
  const [isLoadingFcUsers, setIsLoadingFcUsers] = useState(true);
  const [fcUsersData, setFcUsersData] = useState([]);
  const [noDataFoundVisible, setNoDataFoundVisible] = useState(false);

  //fc boa data
  const [fcBoaActiveFilter, setFcBoaActiveFilter] = useState(4);
  const [isLoadingFcBoa, setIsLoadingFcBoa] = useState(true);
  const [fcBoaData, setFcBoaData] = useState([]);

  //fc family tree
  const [fcFtActiveFilter, setFcFtActiveFilter] = useState(4);
  const [isLoadingFcFt, setIsLoadingFcFt] = useState(true);
  const [fcFtData, setFcFtData] = useState([]);

  //fc status-quo
  const [fcSqActiveFilter, setFcSqActiveFilter] = useState(4);
  const [isLoadingFcSq, setIsLoadingFcSq] = useState(true);
  const [fcSqData, setFcSqData] = useState([]);

  const { branchId, bankId } = filters;

  const initialDatasets = {
    datasets: [
      {
        barThickness: 12,
        label: t("registered-customers"),
        data: [],
      },
    ],
  };

  useEffect(() => {
    if (bankId && branchId === "0000-0000-0000") {
      setFcTotalUsers(0);
      setGeccoTotalUsers(0);
      setGeccoPayedUsers(0);
      setGeccoFilesData(initialDatasets);
      setGeccoUsersData(initialDatasets);
      setFcUsersData(initialDatasets);
      setFcBoaData(initialDatasets);
      setFcFtData(initialDatasets);
      setFcSqData(initialDatasets);
      setIsLoadingFcBoa(false);
      setIsLoadingFcFt(false);
      setIsLoadingFcSq(false);
      setIsLoadingFcUsers(false);
      setIsLoadingGeccoUsers(false);
      setNoDataFoundVisible(true);
    } else {
      usersCount();
      geccoFilesFilter(4);
      geccoUsersStat(4);
      fcUsersStat(4);
      fcBoaStat(4);
      fcFtStat(4);
      fcSqStat(4);
      setNoDataFoundVisible(false);
    }
  }, [branchId]);
  const geccoFilesFilter = async (filter) => {
    let role = JSON.parse(localStorage.getItem("userRole"))?.roleName;
    let payload = "";
    if (role != "#IA") {
      payload = localStorage.getItem("branchId");
    } else {
      payload = branchId;
    }
    setIsLoading(true);
    setGeccoFilesActiveFilter(filter);
    if (branchId !== "0000-0000-0000") {
      const result = await getGeccoFilesStat(filter, payload);
      if (result.success) {
        const geccoFilesBarData = {
          datasets: [
            {
              barThickness: 12,
              label: t("uploaded-bwas"),
              data: localizeGraphData(result?.payLoad),
            },
          ],
        };
        setGeccoFilesData(geccoFilesBarData);
        setIsLoading(false);
      }
    } else {
      toast.error("No branch exists");
      setIsLoading(false);
      noDataFoundVisible(true);
    }
  };
  const usersCount = async () => {
    let role = JSON.parse(localStorage.getItem("userRole"))?.roleName;
    let payload = "";
    if (role != "#IA") {
      payload = localStorage.getItem("branchId");
    } else {
      payload = branchId;
    }
    if (branchId !== "0000-0000-0000") {
      const result = await getUsersCount(payload);
      if (result.success) {
        setFcTotalUsers(result?.payLoad?.futureCareUsersCount);
        setGeccoTotalUsers(result?.payLoad?.geccoUsersCount);
        setGeccoPayedUsers(result?.payLoad?.subscribedGeccoUserCount);
      }
    } else {
      toast.error("No branch exists");
      setIsLoadingFcUsers(false);
      noDataFoundVisible(true);
    }
  };
  const geccoUsersStat = async (filter) => {
    let role = JSON.parse(localStorage.getItem("userRole"))?.roleName;
    let payload = "";
    if (role != "#IA") {
      payload = localStorage.getItem("branchId");
    } else {
      payload = branchId;
    }
    setIsLoadingGeccoUsers(true);
    setGeccoUsersActiveFilter(filter);
    if (branchId !== "0000-0000-0000") {
      const result = await getGeccoUsers(filter, payload);
      if (result.success) {
        const geccoFilesBarData = {
          datasets: [
            {
              barThickness: 12,
              label: t("registered-customers"),
              data: localizeGraphData(result?.payLoad),
            },
          ],
        };
        setGeccoUsersData(geccoFilesBarData);
        setIsLoadingGeccoUsers(false);
      }
    } else {
      toast.error("No branch exists");
      setIsLoadingGeccoUsers(false);
      noDataFoundVisible(true);
    }
  };

  const fcUsersStat = async (filter) => {
    let role = JSON.parse(localStorage.getItem("userRole"))?.roleName;
    let payload = "";
    if (role != "#IA") {
      payload = localStorage.getItem("branchId");
    } else {
      payload = branchId;
    }
    setIsLoadingFcUsers(true);
    setFcUsersActiveFilter(filter);
    if (branchId !== "0000-0000-0000") {
      const result = await getFcUsers(filter, payload);
      if (result.success) {
        const geccoFilesBarData = {
          datasets: [
            {
              barThickness: 12,
              label: t("registered-customers"),
              data: localizeGraphData(result?.payLoad),
            },
          ],
        };
        setFcUsersData(geccoFilesBarData);
        setIsLoadingFcUsers(false);
      }
    } else {
      toast.error("No branch exists");
      setIsLoadingFcUsers(false);
      noDataFoundVisible(true);
    }
  };
  const fcBoaStat = async (filter) => {
    let role = JSON.parse(localStorage.getItem("userRole"))?.roleName;
    let payload = "";
    if (role != "#IA") {
      payload = localStorage.getItem("branchId");
    } else {
      payload = branchId;
    }
    setIsLoadingFcBoa(true);
    setFcBoaActiveFilter(filter);
    if (branchId !== "0000-0000-0000") {
      const result = await getFcBoaData(filter, payload);
      if (result.success) {
        const boaData = {
          datasets: [
            {
              barThickness: 12,
              label: t("assets-documented"),
              data: localizeGraphData(result?.payLoad),
            },
          ],
        };
        setFcBoaData(boaData);
        setIsLoadingFcBoa(false);
      }
    } else {
      toast.error("No branch exists");
      setIsLoadingFcBoa(false);
      noDataFoundVisible(true);
    }
  };
  const fcFtStat = async (filter) => {
    let role = JSON.parse(localStorage.getItem("userRole"))?.roleName;
    let payload = "";
    if (role != "#IA") {
      payload = localStorage.getItem("branchId");
    } else {
      payload = branchId;
    }
    setIsLoadingFcFt(true);
    setFcFtActiveFilter(filter);
    if (branchId !== "0000-0000-0000") {
      const result = await getFcFamilyTreeData(filter, payload);
      if (result.success) {
        const ftData = {
          datasets: [
            {
              barThickness: 12,
              label: t("family-trees-created"),
              data: localizeGraphData(result?.payLoad),
            },
          ],
        };
        setFcFtData(ftData);
        setIsLoadingFcFt(false);
      }
    } else {
      toast.error("No branch exists");

      setIsLoadingFcFt(false);
      noDataFoundVisible(true);
    }
  };
  const fcSqStat = async (filter) => {
    let role = JSON.parse(localStorage.getItem("userRole"))?.roleName;
    let payload = "";
    if (role != "#IA") {
      payload = localStorage.getItem("branchId");
    } else {
      payload = branchId;
    }
    setIsLoadingFcSq(true);
    setFcSqActiveFilter(filter);
    if (branchId !== "0000-0000-0000") {
      const result = await getFcStatusQuoData(filter, payload);
      if (result.success) {
        const sqData = {
          datasets: [
            {
              barThickness: 12,
              label: t("documents-created"),
              data: localizeGraphData(result?.payLoad),
            },
          ],
        };
        setFcSqData(sqData);
        setIsLoadingFcSq(false);
      }
    } else {
      toast.error("No branch exists");
      setIsLoadingFcSq(false);
      noDataFoundVisible(true);
    }
  };
  const options = {
    backgroundColor: [
      "#147AD6",
      "#147AD6",
      "#147AD6",
      "#147AD6",
      "#147AD6",
      "#147AD6",
    ],
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        min: 0,
        //max: 250,
        grid: {
          drawBorder: false,
          display: false,
        },
        ticks: {
          // forces step size to be 50 units
          //stepSize: 1,
          color: "#000000",
          font: {
            family: "Roboto", // Add your font here to change the font of your y axis
            size: 12,
          },
          callback: function (value, index, values) {
            if (Math.floor(value) === value) {
              return value;
            }
          },
        },
      },
      x: {
        grid: {
          drawBorder: false,
          display: false,
        },
        ticks: {
          color: "#000000",
          font: {
            family: "Roboto", // Add your font here to change the font of your y axis
            size: 12,
          },
          // callback: function (label, index, labels) {
          //   return translate_this_label(label);
          // },
        },
      },
    },
  };
  const checkColumnVisibility = (productIds) => {
    return productIds.includes(parseInt(selectedProduct)) ? "block" : "none";
  };
  const checkProductSelection = () => {
    return selectedProduct == -1 ? "d-none" : "d-flex flex-wrap";
  };
  const checkFiltersSeparation = (index) => {
    return index < activitiesFiltersList.length - 1 ? "|" : "";
  };

  const handleChartsData = (isloading, data, option) => {
    if (isloading) {
      return <Loader height={"200px"} />;
    } else if (noDataFoundVisible) {
      return (
        <div className="d-flex justify-content-center align-items-center py-5">
          <p className="fs-5">{t("no-data-available")}</p>
        </div>
      );
    } else {
      return <Bar className="bar-chartjs" data={data} options={option} />;
    }
  };

  return (
    <>
      <div className="activities">
        <div className={checkProductSelection()}>
          <Col
            lg="3"
            sm="12"
            md="6"
            className="mt-3 me-sm-3"
            style={{
              display: checkColumnVisibility([1, 3]),
            }}
          >
            <Card className="justify-content-between h-100">
              <div className="inner">
                <p className="heading">FutureCare</p>
                <span className="activity-count">{t("activity-count")}</span>
                <div className="value">
                  <h1 className="mb-0">{fcTotalUsers}</h1>
                  <span>{t("registered-customers")}</span>
                </div>
              </div>
              <div className="hr"></div>
            </Card>
          </Col>
          <Col
            lg="6"
            sm="12"
            md="12"
            className="mt-3 overflow-x-auto me-sm-3"
            style={{
              display: checkColumnVisibility([1, 3]),
            }}
          >
            <Card className="overflow-x-auto">
              <div className="inner">
                <p className="heading">
                  FutureCare - {t("registered-customers")}
                </p>
                <span className="activity-count">{t("activity-trend")}</span>

                {handleChartsData(isLoadingFcUsers, fcUsersData, options)}
              </div>
              <div className="hr mt-3"></div>
              <div className="d-flex justify-content-center pb-4 filter">
                {activitiesFiltersList.map((item, index) => {
                  return (
                    <>
                      <p
                        onClick={() => {
                          fcUsersStat(item.key);
                        }}
                      >
                        <a
                          className={
                            fcUsersActiveFilter == item.key ? "active" : ""
                          }
                        >
                          {item.label}
                        </a>
                      </p>
                      {checkFiltersSeparation(index)}
                    </>
                  );
                })}
              </div>
            </Card>
          </Col>
        </div>
        <div className={checkProductSelection()}>
          <Col
            lg="3"
            sm="12"
            md="6"
            className="mt-3 me-sm-3"
            style={{
              display: checkColumnVisibility([1, 2]),
            }}
          >
            <Card className="justify-content-between h-100">
              <div className="inner">
                <p className="heading">Gecco</p>
                <span className="activity-count">{t("activity-count")}</span>
                <div className="value">
                  <h1 className="mb-0">{geccoTotalUsers}</h1>
                  <span>{t("registered-customers")}</span>
                </div>
                <div className="value">
                  <h1 className="mb-0">{geccoPayedUsers}</h1>
                  <span>{t("paying-users")}</span>
                </div>
              </div>
              <div className="hr"></div>
            </Card>
          </Col>
          <Col
            lg="6"
            sm="12"
            md="12"
            className="mt-3 overflow-x-auto me-sm-3"
            style={{
              display: checkColumnVisibility([1, 2]),
            }}
          >
            <Card className="overflow-x-auto">
              <div className="inner">
                <p className="heading">Gecco - {t("registered-customers")}</p>
                <span className="activity-count">{t("activity-trend")}</span>

                {handleChartsData(isLoadingGeccoUsers, geccoUsersData, options)}
              </div>
              <div className="hr mt-3"></div>
              <div className="d-flex justify-content-center pb-4 filter">
                {/* <a>1 D.</a>|<a>5 D.</a>|<a>1 M.</a>|
                <a className="active">6 M.</a>|<a>YTD</a>|<a>1 Y.</a>|
                <a>5 Y.</a>|<a>MAX.</a> */}
                {activitiesFiltersList.map((item, index) => {
                  return (
                    <>
                      <p
                        onClick={() => {
                          geccoUsersStat(item.key);
                        }}
                      >
                        <a
                          className={
                            geccoUsersActiveFilter == item.key ? "active" : ""
                          }
                        >
                          {item.label}
                        </a>
                      </p>
                      {checkFiltersSeparation(index)}
                    </>
                  );
                })}
              </div>
            </Card>
          </Col>
          <Col
            lg="6"
            sm="12"
            md="12"
            className="mt-3 overflow-x-auto me-sm-3"
            style={{
              display: checkColumnVisibility([1, 2]),
            }}
          >
            <Card className="overflow-x-auto">
              <div className="inner">
                <p className="heading">Gecco - {t("uploaded-bwas")}</p>
                <span className="activity-count">{t("activity-trend")}</span>

                {handleChartsData(isLoading, geccoFilesData, options)}
              </div>
              <div className="hr mt-3"></div>
              <div className="d-flex justify-content-center pb-4 filter">
                {activitiesFiltersList.map((item, index) => {
                  return (
                    <>
                      <p
                        onClick={() => {
                          geccoFilesFilter(item.key);
                        }}
                      >
                        <a
                          className={
                            geccoFilesActiveFilter == item.key ? "active" : ""
                          }
                        >
                          {item.label}
                        </a>
                      </p>
                      {checkFiltersSeparation(index)}
                    </>
                  );
                })}
              </div>
            </Card>
          </Col>
          <Col
            lg="6"
            sm="12"
            md="12"
            className="mt-3 overflow-x-auto "
            style={{
              display: checkColumnVisibility([1, 3]),
            }}
          >
            <div className="pe-sm-3">
              <Card className="overflow-x-auto">
                <div className="inner">
                  <p className="heading">
                    FutureCare - {t("documents-created")}
                  </p>
                  <span className="activity-count">{t("activity-trend")}</span>

                  {handleChartsData(isLoadingFcSq, fcSqData, options)}
                </div>
                <div className="hr mt-3"></div>
                <div className="d-flex justify-content-center pb-4 filter ">
                  {activitiesFiltersList.map((item, index) => {
                    return (
                      <>
                        <p
                          onClick={() => {
                            fcSqStat(item.key);
                          }}
                        >
                          <a
                            className={
                              fcSqActiveFilter == item.key ? "active" : ""
                            }
                          >
                            {item.label}
                          </a>
                        </p>
                        {checkFiltersSeparation(index)}
                      </>
                    );
                  })}
                </div>
              </Card>
            </div>
          </Col>
          <Col
            lg="6"
            sm="12"
            md="12"
            className="mt-3 overflow-x-auto "
            style={{
              display: checkColumnVisibility([1, 3]),
            }}
          >
            <Card className="overflow-x-auto">
              <div className="inner">
                <p className="heading">FutureCare - {t("assets-documented")}</p>
                <span className="activity-count">{t("activity-trend")}</span>
                {handleChartsData(isLoadingFcBoa, fcBoaData, options)}
              </div>
              <div className="hr mt-3"></div>
              <div className="d-flex justify-content-center pb-4 filter">
                {activitiesFiltersList.map((item, index) => {
                  return (
                    <>
                      <p
                        onClick={() => {
                          fcBoaStat(item.key);
                        }}
                      >
                        <a
                          className={
                            fcBoaActiveFilter == item.key ? "active" : ""
                          }
                        >
                          {item.label}
                        </a>
                      </p>
                      {checkFiltersSeparation(index)}
                    </>
                  );
                })}
              </div>
            </Card>
          </Col>
          <Col
            lg="6"
            sm="12"
            md="12"
            className="mt-3 overflow-x-auto me-sm-3"
            style={{
              display: checkColumnVisibility([1, 3]),
            }}
          >
            <Card className="overflow-x-auto">
              <div className="inner">
                <p className="heading">
                  FutureCare - {t("family-trees-created")}
                </p>
                <span className="activity-count">{t("activity-trend")}</span>

                {handleChartsData(isLoadingFcFt, fcFtData, options)}
              </div>
              <div className="hr mt-4"></div>
              <div className="d-flex justify-content-center pb-4 filter">
                {activitiesFiltersList.map((item, index) => {
                  return (
                    <>
                      <p
                        onClick={() => {
                          fcFtStat(item.key);
                        }}
                      >
                        <a
                          className={
                            fcFtActiveFilter == item.key ? "active" : ""
                          }
                        >
                          {item.label}
                        </a>
                      </p>
                      {checkFiltersSeparation(index)}
                    </>
                  );
                })}
              </div>
            </Card>
          </Col>
        </div>
      </div>
    </>
  );
};

export default Activities;
